import React from 'react'
import { Image, Button } from 'react-bootstrap'

const ImageButton = ({
    src,
    onClick = () => {},
    children
}) => {

    return (
        <Button onClick={onClick} variant="outline-dark">
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}
            >

            </div>
            <Image style={{ height: 100 }} fluid src={src} rounded />
            <div>{children}</div>
        </Button>
    )
}

export default ImageButton